import { Slider } from "@/components/ui/slider";

function getScoreColor(score) {
  if (score >= 8) return "text-green-500";
  if (score >= 6) return "text-blue-400";
  if (score >= 4) return "text-yellow-500";
  return "text-red-500";
}

export function SkillSlider({ skill, value, referenceValue, referencePlayerName, onChange, index }) {
  const Icon = skill.icon;

  return (
    <div 
      className={`p-4 rounded-xl bg-secondary/50 border border-border/50 animate-fadeIn stagger-${index + 1}`}
      style={{ opacity: 0 }}
    >
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon className="h-5 w-5 text-primary" />
          </div>
          <div>
            <p className="font-bold">{skill.label}</p>
            <p className="text-xs text-muted-foreground">{skill.description}</p>
          </div>
        </div>
        <div className={`slider-value ${getScoreColor(value)}`}>
          {value.toFixed(1)}
        </div>
      </div>
      <div className="skill-slider">
        <Slider
          value={[value]}
          onValueChange={onChange}
          max={10}
          min={0}
          step={0.5}
          className="w-full"
          data-testid={`slider-${skill.key}`}
        />
      </div>

      {referencePlayerName && referenceValue !== undefined && (
        <div className="mt-3 space-y-1">
          <div className="flex justify-between text-[10px] text-muted-foreground">
            <span>Comparação com {referencePlayerName}</span>
            <span>{value.toFixed(1)} vs {referenceValue?.toFixed?.(1) ?? '--'}</span>
          </div>
          <div className="h-2 rounded-full bg-muted overflow-hidden relative">
            <div className="absolute left-0 top-0 h-full bg-red-500/50 rounded-full" style={{ width: `${(referenceValue / 10) * 100}%` }} />
            <div className="absolute left-0 top-0 h-full bg-primary/80 rounded-full" style={{ width: `${(value / 10) * 100}%` }} />
          </div>
        </div>
      )}
    </div>
  );
}
